import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { SITE_REFUSED_USE_EXTENSION_COPY } from '@overlayqa/shared/reviewSiteRefused';

/** Consume the finish failure only after Layout's notification renderers mount. */
export function OnboardingReviewNotice() {
  const location = useLocation();
  const navigate = useNavigate();
  const displayedKey = useRef<string | null>(null);
  useEffect(() => {
    const reason = location.state?.onboardingReviewFailure;
    // The pre-check found a site that refuses our server: retrying team review cannot help.
    const siteRefused = location.state?.onboardingSiteRefused === true;
    if ((typeof reason !== 'string' && !siteRefused) || displayedKey.current === location.key) return;
    displayedKey.current = location.key;
    toast.error('Your project is saved, but team review could not open.', {
      id: 'onboarding-review-failed',
      description: typeof reason === 'string'
        ? `${reason} Open your project to try team review again.`
        : SITE_REFUSED_USE_EXTENSION_COPY,
      duration: Infinity,
    });
    // Consume the handoff so Back or a refresh cannot repeat an old failure.
    const state = { ...location.state };
    delete state.onboardingReviewFailure;
    delete state.onboardingSiteRefused;
    navigate(location.pathname + location.search + location.hash, { replace: true, state });
  }, [location, navigate]);
  return null;
}
